import React from 'react';

interface Props {
  html: string;
}

function RichTextContent({ html }: Props) {
  return (
    <div
      className="blog-prose"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default RichTextContent;
